module.exports = __webpack_public_path__ + "static/media/Justine.b023c779.png";